import { MeasurementName } from '@quromedical/models';

const getSpotCheckLowConfidence = value => {
  const lowConfidenceValues = ['0', '-1', 0, -1];
  const isLowConfidence = lowConfidenceValues.includes(value);

  if (!isLowConfidence) {
    return {};
  }

  return {
    lowConfidence: true
  };
};

/**
 * Currently this does not account for the fact that we could have different devices for the same message.
 */
const supplementaryMetaMap = {
  [MeasurementName.SystolicArterialBloodPressure]: getSpotCheckLowConfidence,
  [MeasurementName.DiastolicArterialBloodPressure]: getSpotCheckLowConfidence,
  [MeasurementName.MeanArterialBloodPressure]: getSpotCheckLowConfidence,
  [MeasurementName.OxygenSaturation]: getSpotCheckLowConfidence,
  [MeasurementName.HeartRate]: getSpotCheckLowConfidence,
  [MeasurementName.PerfusionIndex]: getSpotCheckLowConfidence
};
export const getMetadata = record => {
  const getSupplementaryMetaData = supplementaryMetaMap[record.measurementName];

  if (!getSupplementaryMetaData) {
    return {};
  }

  return getSupplementaryMetaData(record.value);
};
export const isValidReading = record => {
  var _record$meta;

  const metadata = getMetadata(record);
  const isLowConfidence = metadata.lowConfidence || ((_record$meta = record.meta) === null || _record$meta === void 0 ? void 0 : _record$meta.lowConfidence);
  return !isLowConfidence;
};
//# sourceMappingURL=metadata.js.map